<template>
  <div>
    <div class="box" v-for="(item, index) in list" :key="index">
      <div class="title">
        <div class="methodTitle">
          <h3 class="lable">ICCID:</h3>
          <h3>{{ item.iccid }}</h3>
        </div>
        <div class="methodSlidebt">
          <ul>
            <li> <h3>运营商</h3> <p>{{ item.store_name }}</p> </li>
            <li> <h3>状态</h3> <p>{{ item.status }}</p> </li>
            <li> <h3>剩余流量</h3> <p>{{ item.remain_flow }}MB</p> </li>
          </ul>
        </div>
      </div>
      <div class="btn">
        <van-button plain round size="small" color="#FF4427" @click="boxBtn(item.iccid)">详情</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {
    boxBtn (e) {
      this.$router.push({ name: 'Recharge', params: { iccid: e } })
    }
  },
  beforeCreate () {},
  created () {
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  /deep/.van-cell__value {
    flex: 2;
  }
  .ckxq {
    /deep/.van-cell__value {
      color: rgb(42, 111, 238)!important;
    }
  }
  .weappIcon {
    font-size: 40px;
    line-height: inherit;
  }
  [class*=van-hairline]::after {
    border: none;
  }
  .box {
    width: 690px;
    height: 180px;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15,27,115,8%);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      flex: 2;
      .methodTitle {
        display: flex;
        justify-content: space-between;
        padding: 40px 0 0 40px;
        h3 {
          font-size: 30px;
          color: #272729;
          line-height: 20px;
          font-weight: 400;
        }
        .lable {
          margin-right: 15px;
        }
      }
      .methodSlidebt {
        padding: 10px 0 0 40px;
        ul {
          display: flex;
          justify-content: space-between;
          height: 100px;
          li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            h3 {
              line-height: 18px;
              font-size: 25px;
              color: #9D9DA3;
            }
            p {
              line-height: 20px;
              font-size: 25px;
              color: #272729;
            }
          }
        }
      }
    }
    .btn {
      flex: 1;
      text-align: center;
      padding-left: 20px;
      .van-button {
        width: 100px;
      }
    }
  }
  .box:after {
    display: block;
    content: "";
    width: 32px;
    height: 32px;
    background: url(../assets/yans-2.png) no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
</style>
